import React from 'react';
import { useChatWidgetContext } from '@/widget/services/useChatWidgetContext';
import { ReactSVG } from 'react-svg';
import chevron from '@/widget/ui/images/chevron-right.svg';
import { useStore } from 'zustand';
import cx from 'classnames';
import styles from './ListHeader.module.scss';

function ListHeader() {
  const { settings, store } = useChatWidgetContext();
  const {
    isMobile, host, color: backgroundColor, textColor: color,
  } = settings;
  const setMode = useStore(store, (state) => state.setMode);
  const previousMode = useStore(store, (state) => state.previousMode);

  return (
    <div style={{ backgroundColor, color }} className={cx(styles.container, { [styles.mobile]: isMobile })}>
      <div
        className={styles.backButton}
        onClick={() => setMode(previousMode)}
      >
        <ReactSVG src={host + chevron} />
      </div>
      <div className={styles.caption}>
        {window.ChatWidget.i18n.t('chat_widget.lastConversations')}
      </div>
    </div>
  );
}

export default ListHeader;
